import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './WireInfoComponent.css';
import ListItemTR from '../../UI/ListItems/TwoRowsListItem/ListItemTR';
import wireData from '../../../assets/data/AppData/Canada/WireData/MaxConductorsNumber.json';
import WireTable from '../WireTable/WireTable';
import translation from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const parseWireURIElement = wireURIelement => {
  let wire = wireURIelement;
  wire = wire.replace(/-/g, '/');
  wire = `${wire.substr(0, wire.length - 9)} ${wire.substr(-9)}`;
  return wire;
};

const wireInfoComponent = props => {
  const { match, country, language } = props;
  const slectedAWG = parseWireURIElement(match.params.awg);

  return (
    <Fragment>
      <div className={classes.MainInfoWrapper}>
        <ListItemTR
          title={translation[language]['copperAmpacity']}
          value={wireData[slectedAWG][Object.keys(wireData[slectedAWG])[0]]}
        />
        <ListItemTR
          title={translation[language]['aluminumAmpacity']}
          value={wireData[slectedAWG][Object.keys(wireData[slectedAWG])[1]]}
        />
      </div>
      <WireTable
        className={classes.Table}
        country={country}
        language={language}
        selectedAWG={slectedAWG}
      />
      <div className={classes.TitleWrapper}>
        <h2>{slectedAWG}</h2>
      </div>
    </Fragment>
  );
};

wireInfoComponent.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired
};

export default withRouter(wireInfoComponent);
